import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ADPResourceService } from 'digital-core';
import { SnackbarService } from 'src/app/core/services/snackbar/snackbar.service';
import { IDeviceCardDetails } from 'src/app/shared/device/device-card/device-card.component';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'pgh-resume-diagnostic-test',
  templateUrl: './resume-diagnostic-test-modal.component.html',
  styleUrls: ['./resume-diagnostic-test-modal.component.scss']
})
export class ResumeDiagnosticTestModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ResumeDiagnosticTestModalComponent>,
    public resourceService: ADPResourceService,
    private selectedDeviceService: SelectedDeviceService,
    private clipboard: Clipboard,
    private snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) { }

  public hylaLink: string;
  public elementType: string;
  public value:string;
  public deviceTypeCode: string;
  public altLinkMessage: string;
  public isUsingMobile:boolean = false;
  public correctionLevel:string ;

  public isTablet:boolean = false;
  public isSmartwatch:boolean = false;

  ngOnInit() {

    // TODO: Should we only show the alt text link if using mobile, hidden for desktop?
    this.isUsingMobile = this.isUserUsingMobile();

    this.deviceTypeCode = this.dialogData.deviceTypeCode;

    if(this.deviceTypeCode === 'TABL'){
      this.isTablet = true;
    }else if(this.deviceTypeCode === 'SMAR'){
      this.isSmartwatch = true;
    }

    const imeiBase64 = btoa(this.dialogData.imei);

    const hylaUrl = this.isTablet? this.resourceService.getPortalSetting("URL_Hyla_Tablet").Value :
                    this.isSmartwatch? this.resourceService.getPortalSetting("URL_Hyla_Smartwatch").Value : '';

    this.hylaLink = hylaUrl.replace(/{{code}}/g, this.dialogData.invitationCode);
    this.hylaLink = this.hylaLink.replace(/{{imeiBase64}}/g, imeiBase64);

    this.elementType = 'url';
    this.correctionLevel = 'H';
    this.value = this.hylaLink;

    // TODO: Remove later, just keeping if there are decision shifts, but this is not being used anymore
    //const altText = this.resourceService.getPortalLabel("RegisterCellularDevice_QRCode_Link_Alt_Text").Value;
    //const linkText = "<a class='link' id='myButton' onclick='onAltTextClicked(event)' target='_blank' href='" + this.hylaLink + "'>Copy the URL</a>";
    //this.altLinkMessage = altText.replace(/{{here}}/g, linkText);

  }

  onCancelClicked() {
    this.dialogRef.close({ data: 'cancel' });
  }

  onAltTextClicked(event){

      // TODO: Trying to close modal when link clicked, which opens a new tab. May not be possible?
      event.preventDefault();
      this.dialogRef.close({ data: 'cancel' });
      window.location.href = event.currentTarget.href;

  }

  copyToClipboard(){
    this.clipboard.copy(this.hylaLink);
    this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue("RegisterCellularDevice_QRCode_Link_CopyClipboard"));
  }

  isUserUsingMobile() : boolean {

      // User agent string method
      let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      // Screen resolution method
      if (!isMobile) {
          let screenWidth = window.screen.width;
          let screenHeight = window.screen.height;
          isMobile = (screenWidth < 768 || screenHeight < 768);
      }

      // Touch events method
      if (!isMobile) {
          isMobile = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
      }

      // CSS media queries method
      if (!isMobile) {
          let bodyElement = document.getElementsByTagName('body')[0];
          isMobile = window.getComputedStyle(bodyElement).getPropertyValue('content').indexOf('mobile') !== -1;
      }

      return isMobile

  }

}
